var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 114,
    viewBox: "0 0 150 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 148,
    height: 132,
    rx: 8,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 108.429,
    width: 13,
    height: 24.5714,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 101.786,
    width: 13,
    height: 31.2143,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 98.0953,
    width: 13,
    height: 34.9048,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 86.2857,
    width: 13,
    height: 46.7143,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 60,
    width: 13,
    height: 73,
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.853 36.1199L131.415 30.2717L130.199 44.0747L118.853 36.1199Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3214 98.9954C38.9168 100.201 94.0741 90.5086 127.386 41.9808L125.324 40.5659C92.664 88.1453 38.5 97.6765 15.449 96.4987L15.3214 98.9954ZM15.551 94.5013L15.6786 92.0046C37.7499 93.1323 90.1259 83.8914 121.614 38.0192L123.676 39.4341C91.536 86.2547 38.1666 95.6568 15.551 94.5013Z",
    fill: "#2369CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 45,
    r: 31.5,
    stroke: "#2369CC",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3542 33.4286H48.3195H33.2375C33.1561 33.4286 33.0927 33.4593 33.0521 33.4979C33.0124 33.5357 33 33.5741 33 33.6071V37.5357C33 37.5688 33.0124 37.6071 33.0521 37.6449C33.0927 37.6836 33.1561 37.7143 33.2375 37.7143H49.6093H50.8064L50.5933 38.8923C50.2327 40.886 49.2624 42.5558 47.7365 43.7181C46.2184 44.8744 44.2247 45.4728 41.9 45.4728H33.2375C33.1561 45.4728 33.0927 45.5035 33.0521 45.5421C33.0124 45.58 33 45.6183 33 45.6514V50.8579C33 50.8903 33.0138 50.9336 33.0584 50.9729L50.3542 33.4286ZM50.3542 33.4286L49.1112 31.8177C47.5694 29.8195 45.0825 28.752 42.032 28.752H33.2375C33.1561 28.752 33.0927 28.7213 33.0521 28.6827C33.0124 28.6449 33 28.6065 33 28.5735V24.1786C33 24.1455 33.0124 24.1072 33.0521 24.0693C33.0927 24.0307 33.1561 24 33.2375 24H63.7625C63.8439 24 63.9073 24.0307 63.9479 24.0693C63.9876 24.1072 64 24.1455 64 24.1786V28.1071C64 28.1402 63.9876 28.1785 63.9479 28.2164C63.9073 28.255 63.8439 28.2857 63.7625 28.2857H56.2404H54.4087L55.3992 29.8265C55.9664 30.7088 56.4235 31.6798 56.7569 32.7309L56.9782 33.4286H57.7101H63.7625C63.8439 33.4286 63.9073 33.4593 63.9479 33.4979C63.9876 33.5357 64 33.5741 64 33.6071V37.5357C64 37.5688 63.9876 37.6071 63.9479 37.6449C63.9073 37.6836 63.8439 37.7143 63.7625 37.7143H58.3164H57.4124L57.3214 38.6137C56.6367 45.3867 51.4571 50.0603 44.0232 50.2769L41.4849 50.3509L43.3921 52.0275L58.9517 65.7064C58.9999 65.7487 59.0079 65.7783 59.0105 65.7903C59.0143 65.8084 59.0142 65.8365 59.0001 65.8708C58.986 65.9052 58.9614 65.9365 58.9291 65.9588C58.9008 65.9782 58.8535 66 58.7727 66H50.2585C50.1846 66 50.1211 65.9731 50.0794 65.9364C50.0794 65.9364 50.0794 65.9364 50.0794 65.9364L33.0585 50.9729L50.3542 33.4286Z",
    stroke: "#2369CC",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 92,
    x2: 16,
    y2: 99,
    stroke: "#2369CC",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateChartIcon);
export default __webpack_public_path__ + "static/media/rate-chart-icon.7002e2973815c4c3e66e7fc4efb08408.svg";
export { ForwardRef as ReactComponent };